import { useInternalNode } from "@xyflow/react";

// Until react-flow has measured a node, NodeToolbar positions itself against a
// 0x0 box and lands on the node body, where a click hits the wrong target.
export const useIsNodeMeasured = (nodeId: string): boolean => {
  const measured = useInternalNode(nodeId)?.measured;

  return (measured?.width ?? 0) > 0 && (measured?.height ?? 0) > 0;
};
